import React from "react";
import PropTypes from "prop-types";

import ProjectForm from "../../project/ProjectForm";

import Modal from "../../common/Modal";

const ProjectDetailsModal = ({ project, handleClose, handleCancel }) => (
  <Modal
    id="projectDetailsModal"
    title="Project Details"
    body={<ProjectForm project={project} onCancel={handleClose} />}
    close={handleCancel}
  />
);
ProjectDetailsModal.propTypes = {
  project: PropTypes.object,
  handleCancel: PropTypes.func,
  handleClose: PropTypes.func
};
export default ProjectDetailsModal;
